import { useEffect } from "react"
import { isPdmStructureV2Enabled } from "../helpers/flags/isPdmStructureV2Enabled"
import { loadPdmVehicleCatalogIntoStore } from "../helpers/vehicle/loadPdmVehicleCatalogIntoStore"

/**
 * Site-wide PDM vehicle catalog preload, mounted once in `Layout`.
 *
 * When `NEXT_PUBLIC_UPHOLSTERY_PDM_V2_STRUCTURE=true`, calls
 * `loadPdmVehicleCatalogIntoStore()` — fetch once per browser tab, then
 * reuse the shared store on navigation. No Dato fallback.
 *
 * Does **not** cancel on unmount: Pages Router remounts Layout on each
 * navigation, and cancelling would abort the first fetch mid-flight.
 *
 * When the flag is off this is a complete no-op: no PDM request and no store
 * writes. Legacy Dato fetching remains in `useFetchUpholsteryCars` (flag off only).
 */
export function useGlobalVehicleCatalogLoader(): void {
  useEffect(() => {
    if (!isPdmStructureV2Enabled()) {
      return
    }

    void loadPdmVehicleCatalogIntoStore()
  }, [])
}
